import hampshireLogo from '../assets/img/hampshire-logo.png';

const WHITE_LABELS = {
  hampshire: {
    alt: 'Hampshire',
    logo: hampshireLogo,
  },
};

export function getWhiteLabelBrand() {
  const label = String(window.userSession?.white_label || '').trim().toLowerCase();
  return WHITE_LABELS[label] || null;
}
